// import { Trans } from '@lingui/react';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { AuthApi } from '../api/AuthApi';
import FormComponent from '../components/FormComponent';
import MessageView from '../components/MessageView';
import { AuthContext } from '../context/AuthContext';


const ChangePasswordOnLogin = FormComponent({
    displayName: 'ChangePasswordOnLogin',
    schema: {
        title: "Cambiar contraseña",
        description: "Por seguridad, por favor cambie su contraseña.",
        type: "object",
        properties: {
            password: {title: "New Password", type: "string"},
            passwordConfirm: {title: "Confirm Password", type: "string"},
        },
        required: ["password", "passwordConfirm"],
    },
    uiSchema: {
        password: {"ui:widget": "password"},
        passwordConfirm: {"ui:widget": "password"},
    },
    parseProps({ match: {params: {token}}}) {
        const auth = useContext(AuthContext);
        return {auth};
    },
    async onSubmit({formData: {password, passwordConfirm}}, {props: {auth}}) {
        await auth.changePassword({ password, passwordConfirm });
    },
    validate({password, passwordConfirm}, errors){
        if (password !== passwordConfirm) {
            errors.passwordConfirm.addError("Las contraseñas no son iguales");
        }
        return errors;
    },
    renderFormChildren: () => (
        <Row>
            <Col><Button color="primary" type="submit">Cambiar contraseña</Button></Col>
        </Row>
    ),
    renderFormSubmitted: () => (
        <MessageView title="Contraseña olvidada">
            <div>Su contraseña ha sido cambiada exitosamente.</div>
            <br />
            <Link component={Button} color="primary" to="/"> Ir a Bandeja de Trabajo</Link>
        </MessageView>
    )
})


export default ChangePasswordOnLogin;